import { LabeledText } from "../LabeledText/LabeledText";

import type { JSX } from "react";
import { useTranslation } from "react-i18next";

import { FormattedStaticCurrencyNumber } from "@4pace-cpq/core";
import { VMLineItems } from "@4pace-cpq/core/api";

export function SumListPrice({ item }: { item: VMLineItems }): JSX.Element {
  const { t } = useTranslation();

  const currencyIdentifier = item.currency?.identifier;

  return (
    <LabeledText
      label={t("regiolux:item.property.label.totalList")}
      text={
        <FormattedStaticCurrencyNumber
          value={item.totalList}
          currencyIdentifier={currencyIdentifier}
        />
      }
    />
  );
}
